import React from 'react';
import BasicGraph from '../depreciated/BasicGraph';
import Iframe from "react-iframe";
import Sqncr3D from "../components/Sqncr3D";
import OrderBook3D from "../components/OrderBook3D";
import MarketWatchlist from "../components/MarketWatchlist";
import EcoCalendar from "../components/EcoCalendar";
import WalletWatchlist from "../components/WalletWatchlist";

const BTN = {
  background: '#383838', color: '#aaa', border: '1px solid #444',
  borderRadius: '3px', padding: '2px 8px', fontSize: '9px',
  cursor: 'pointer', letterSpacing: '0.5px', marginRight: '6px',
  fontFamily: 'inherit', lineHeight: 'normal'
};

function openTab(url) {
  const a = document.createElement('a');
  a.href = url;
  a.target = '_blank';
  a.rel = 'noreferrer';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

class Models extends React.Component {
  constructor(props) {
    super(props);
    this.state = { showOrderBook: false };
  }

  render() {
    const { showOrderBook } = this.state;
    return (
      <div className={"page-models"}>
        <div className={"models-border"}>
          <div className={"models-border-content"}>

            {/* Button bar — between outer and inner border lines */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '4px 2px' }}>

              <button style={BTN} onClick={() => window.location.href = '/blocks'}>
                BLOCKS
              </button>
              <button style={BTN} onClick={() => window.location.href = '/clients/index.html'}>
                CLIENT
              </button>
            </div>

            <div className={"models-border-2"}>
              <div className={"models-border-content-2"}>

                <div className={"models-content"}>
                  <div className="top-row">
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <MarketWatchlist />
                      <EcoCalendar />
                    </div>
                    <div style={{ flex: 1, minWidth: 0, position: 'relative', height: '450px', pointerEvents: showOrderBook ? 'auto' : 'none' }}>
                      {showOrderBook && <OrderBook3D />}
                      <button
                        onClick={() => this.setState({ showOrderBook: !showOrderBook })}
                        className="btn-toggle-3d"
                        style={{
                          position: 'absolute', bottom: 8, right: 8, zIndex: 10,
                          background: '#2a2a2a', color: '#aaa', border: '1px solid #444',
                          borderRadius: '3px', padding: '1px 4px', fontSize: '7px',
                          cursor: 'pointer', letterSpacing: '0.5px', pointerEvents: 'auto'
                        }}
                      >
                        {showOrderBook ? 'HIDE 3D' : 'SHOW 3D'}
                      </button>
                    </div>
                    <WalletWatchlist />
                  </div>
                  <div style={{ position: 'relative', width: '100%' }}>
                    <Sqncr3D/>
                    <button
                      style={{ ...BTN, position: 'absolute', bottom: 8, right: 8, zIndex: 10, marginRight: 0 }}
                      onClick={() => window.location.href = '/info'}
                    >
                      INFO
                    </button>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Models;
